import { frontendURL } from '../../../../helper/URLHelper';

const SettingsContent = () => import('../Wrapper.vue');
const Index = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/setup'),
      component: SettingsContent,
      props: {
        // Wrapper.vue runs this through $t, so it is the KEY, not the string.
        headerTitle: 'SETUP_CHECKLIST.HEADER',
        icon: 'checkmark-circle',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'settings_setup_wrapper',
          // administrator-only, because every destination on the list is.
          // An agent could complete exactly one of these steps, so an
          // agent-visible checklist would be six statements they cannot act on.
          roles: ['administrator'],
          redirect: 'checklist',
        },
        {
          path: 'checklist',
          name: 'settings_setup_checklist',
          roles: ['administrator'],
          component: Index,
        },
      ],
    },
  ],
};
